// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"346":"ab82233d","499":"c643c5eb"}[chunkId] + ".chunk.css";
};